import { cn } from "@/lib/utils";

/**
 * Loading placeholder. The skill requires skeletons that match the real
 * layout rather than a lone spinner, so these are always composed into a
 * shape (see shared/table-skeleton.tsx), never used bare as a page loader.
 */
function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      aria-hidden="true"
      {...props}
    />
  );
}

export { Skeleton };
